














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Router from 'vue-router';
import Card from '../shared/Card.vue';
import DisabledInput from '@/components/shared/DisabledInput.vue';
import SingleBlockDetail from './SingleBlockDetail.vue';
import SingleBlockEventDetail from './SingleBlockEventDetail.vue';
import SingleBlockExtrinsicsDetail from './SingleBlockExtrinsicsDetail.vue';

@Component({
  components: {
    Card,
    DisabledInput,
    SingleBlockDetail,
    SingleBlockEventDetail,
    SingleBlockExtrinsicsDetail
  },
})
export default class BlockDetails extends Vue {
	@Prop(String) public lastBlock!: string;
  @Prop(String) public chainName!: string;
  @Prop() public queryBlock!: string;
}
